import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Form,
  Input,
  Container,
  Row,
  Col,
  FormGroup,
  Label,
} from "reactstrap";
import Navigate from "@components/Navigate";
import { login, verify } from "@network/Auth/apiAuth";
import { useDispatch } from "react-redux";
import { updateUser } from "@store/authReducer";
import { updateNotice } from "@store/noticeReducer";
import OtpInput from "react-otp-input";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import DashboardConstant from "@views/Pages/Dashboard/landing-image.constant";
import { Errors } from "@const/error";
import { RequestLogin } from "@network/Auth/type";
import { routes } from "@const/routes";
import styled from "styled-components";
import PopUp from "@components/PopUp";
import { PopupWrapper } from "@components/Footer";
import { EncryptService } from "@utils/encrypt.service";
import DecryptedData from "@utils/decrypdata.service";
import { useImagePath } from "@components/HeaderBar/imageTheme";
import dabur1 from "@assets/img/dabur1.png"
import dabur2 from "@assets/img/dabur2.png"
import dabur3 from "@assets/img/dabur3.png"
import dabur4 from "@assets/img/dabur4.png"
import signup from "@assets/img/sign-up.png";
import welcome from "@assets/img/welcome.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import HeaderBar from "@components/HeaderBar";
import { SwiperWrapper } from "@components/RaffleSwiper/style";
import img from "@assets/img";
import { getAllRaffleData } from "@network/Raffle";

const ContainerNavigate = styled.div`
    width: 100%;
    display: none;
    @media screen and (max-width: 768px) {
      position: sticky;
      top: 0;
      background-color: transparent;
      z-index: 99;
      display: block;
    }
  `;

export const Title = styled.h3`
    font-size: var(--font-size-3xl);
    font-weight: var(--font-weight-bold);

    @media (max-width: var(--breakpoint-sm)) {
      font-size: var(--font-size-md);
    }
  `;

export const PolicyDescription = styled.div`
    font-size: var(--font-size-sm);
    line-height: 1.5em;
    margin-bottom: var(--spacing-xs);
    font-family: 'Poppins Bold', Poppins, roboto, 'Helvetica Neue', Arial !important;
    font-weight: var(--font-weight-bold);
    @media (max-width: 767px) {
      font-size: var(--font-size-xs);
    }
  `;

export const Link = styled.a`
    font-size: var(--font-size-sm);
    color:var(--hover-color) !important;
    text-decoration: underline;
    @media (max-width: var(--breakpoint-sm)) {
      font-size: var(--font-size-xs);
    }
  `;



// export const Title = styled.h3`
//   font-size: 48px;
//   font-weight: 700;
//   @media (max-width: 767px) {
//     font-size: 32px;
//   }
// `;

// export const PolicyDescription = styled.div`
//   font-size: 15px;
//   line-height: 1.5em;
//   margin-bottom: 5px;
//   @media (max-width: 767px) {
//     font-size: 12px;
//   }
// `;

// export const Link = styled.a`
//   font-size: 15px;
//   @media (max-width: 767px) {
//     font-size: 12px;
//   }
// `;

const privateKey = process.env.REACT_APP_PRIVATE_KEY as string;

const imageurls = [
  { id: 1, url: dabur1 },
  { id: 2, url: dabur2 },
  { id: 3, url: dabur3 },
  { id: 4, url: dabur4 },
  { id: 5, url: dabur1 },
  { id: 6, url: dabur2 },
]

const Preview: React.FC = () => {
  const { id } = useParams();
  const [phone, setPhone] = useState<string | undefined>();
  const [otp, setOtp] = useState<string>();
  const [isCheck, setIsCheck] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [showTermAndCondition, setShowTermAndCondition] =
    useState<boolean>(false);
  const [showConsentForm, setShowConsentForm] = useState<boolean>(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] =
    useState<boolean>(false);
  const [payloadFromGift, setPayloadFromGift] = useState<any>();
  const [isInValidPhone, setIsInValidPhone] = useState<boolean>(false);
  const [showOtp, setShowOtp] = useState<boolean>(false);
  const [isResend, setIsResend] = useState<boolean>(false);
  const [timer, setTimer] = useState<number>(0);
  const [theme, setTheme] = useState({
    logoUrl: "",
    logoImage1: "",
    logoImage2: "",
    logoImage3: "",
    logoImage4: "",
  });
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const imagePath = useImagePath();
  const [navbar, setNavbar] = useState(false);

  const consentChecked = localStorage.getItem("consentChecked") === "true";
  const [consent, setConsent] = useState(consentChecked);
  const [raffleData, setRaffleData] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  // let imageurls: any[] = []

  useEffect(() => {
    const interval = setInterval(() => {
      if (timer - 1 === 0) {
        setIsResend(true);
        clearInterval(interval);
      }
      setTimer((prevTimer) => (prevTimer - 1 >= 0 ? prevTimer - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  useEffect(() => {
    const giftCode = localStorage.getItem("giftCode");
    if (giftCode) {
      const encrypt = new EncryptService();
      const payload: any = encrypt.decryptUseAES(
        giftCode,
        privateKey,
        DecryptedData
      );
      const parsedPayload = JSON?.parse(payload);
      setPayloadFromGift(parsedPayload);
    }
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'SET_THEME') {
        const payload = event.data.payload;
        if (payload.primaryColor) {
          document.body.style.setProperty('--primary-color', payload.primaryColor);
        }
        if (payload.secondaryColor) {
          document.body.style.setProperty('--secondary-color', payload.secondaryColor);
        }

        if (payload.primaryButtonColor) {
          document.body.style.setProperty('--primary-button-color', payload.primaryButtonColor)
        }
        if (payload.primaryButtonLabelColor) {
          document.body.style.setProperty('--primary-button-label-color', payload.primaryButtonLabelColor)
        }

        if (payload.backgroundColor) {
          document.body.style.setProperty('--background-color', payload.backgroundColor)
          document.body.style.setProperty('--background-image', 'none');
        }

        if (payload.tertiaryColor) {
          document.body.style.setProperty('--tertiary-color', payload.tertiaryColor)
        }

        if (payload.containerTwoBg) {
          document.body.style.setProperty('--container-two-bg', payload.containerTwoBg)
        }
        if (payload.gradientColor) {
          document.body.style.setProperty('--gradient-color', payload.gradientColor)
        }
        if (payload.iconColors) {
          document.body.style.setProperty('--icon-colors', payload.iconColors)
        }
        if (payload.errorColor) {
          document.body.style.setProperty('--error-color', payload.errorColor)
        }
        if (payload.successColor) {
          document.body.style.setProperty('--success-color', payload.successColor)
        }
        if (payload.infoColor) {
          document.body.style.setProperty('--info-color', payload.infoColor)
        }
        if (payload.placeholderColor) {
          document.body.style.setProperty('--placeholder-color', payload.placeholderColor)
        }
        if (payload.inputBorderColor) {
          document.body.style.setProperty('--input-border-color', payload.inputBorderColor)
        }
        if (payload.inputTextColor) {
          document.body.style.setProperty('--input-text-color', payload.inputTextColor)
        }
        if (payload.inputBackgroundColor) {
          document.body.style.setProperty('--input-background-color', payload.inputBackgroundColor)
        }
        if (payload.focusColor) {
          document.body.style.setProperty('--focus-color', payload.focusColor)
        }
        if (payload.hoverColor) {
          document.body.style.setProperty('--hover-color', payload.hoverColor)
        }
        if (payload.disabledButtonBorderColor) {
          document.body.style.setProperty('--disabled-button-border-color', payload.disabledButtonBorderColor)
        }
        if (payload.disabledButtonLabelColor) {
          document.body.style.setProperty('--disabled-button-label-color', payload.disabledButtonLabelColor)
        }
        if (payload.primaryLabelColor) {
          document.body.style.setProperty('--primary-label-color', payload.primaryLabelColor)
        }
        if (payload.secondaryLabelColor) {
          document.body.style.setProperty('--secondary-label-color', payload.secondaryLabelColor)
        }
        if (payload.backgroundColorType === 'gradient' && payload.backgroundFromColor && payload.backgroundToColor) {
          document.body.style.setProperty('--background-color', `linear-gradient(341.1deg, ${payload.backgroundFromColor} -28.66%, ${payload.backgroundToColor} 87.23%)`);
          document.body.style.setProperty('--background-image', 'none');
        }
        if(payload.tertiaryLabelColor){
          document.body.style.setProperty('--tertiary-label-color', payload.tertiaryLabelColor);
        }
        // Set logo if present
        if (payload.logoUrl) {
          const logoUrlImg = document.querySelector('img[alt="logo"]') as HTMLImageElement;
          document.body.style.setProperty('--header-logo-size', '50px');
          if (logoUrlImg) {
            logoUrlImg.src = payload.logoUrl;
          }
        }

        setTheme({
          logoUrl: payload.logoUrl,
          logoImage1: payload.logoImage1,
          logoImage2: payload.logoImage2,
          logoImage3: payload.logoImage3,
          logoImage4: payload.logoImage4,
        });
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const fetchRaffleData = async () => {
    try {
      const res = await getAllRaffleData();
      if (res.code === 200) {
        const mapped = res.data.map((item: any) => ({
          id: item.id,
          url: item.thumbnailImg ? 'https://wnnr.fsn1.your-objectstorage.com/' + item.thumbnailImg : item.bannerUrl,
        }));
        setRaffleData(mapped);
        setLoading(false);
      } else {
        setRaffleData([]);
        setLoading(false);
      }
    } catch (error) {
      setRaffleData([]);
      setLoading(false);
      console.error("Failed to fetch raffle data:", error);
    }
  }


  useEffect(() => {
    fetchRaffleData()
  }, [])

  const onSend = async () => {
    try {
      if (isError || !phone) return;
      const res = await login({
        phone,
        ...(payloadFromGift ? { source: payloadFromGift.source } : {}),
      });
      if (res.status === "error") {
        return dispatch(
          updateNotice(
            {
              type: "ERROR",
              content: Errors[res.message]
                ? Errors[res.message]
                : Errors.SEND_OTP_ERROR,
            },
            dispatch
          )
        );
      }

      setShowOtp(true);

      setTimer(59);
    } catch (error) {
      console.log(error);
    }
  };

  const onVerify = async () => {
    try {
      if (!otp || !isCheck || !phone) {
        setIsError(true);

        return;
      }

      setIsError(false);
      const verifyPayload: RequestLogin = {
        phone,
        otp,
        ...(payloadFromGift ? { source: payloadFromGift.source } : {}),
      };
      if (id) verifyPayload.invitedBy = Number(id);

      const res = await verify(verifyPayload);

      if (res.status === "error") {
        localStorage.removeItem("giftCode");
        return dispatch(
          updateNotice(
            {
              type: "ERROR",
              content: Errors[res.message]
                ? Errors[res.message]
                : Errors.VERIFY_OTP_ERROR,
            },
            dispatch
          )
        );
      }
      localStorage.removeItem("giftCode");
      dispatch(updateUser(res.data));
      navigate(routes.dashboard);
    } catch (error) {
      console.log(error);
    }
  };

  const showTime = (timer: number) =>
    timer > 9 ? `00:${timer}` : `00:0${timer}`;

  useEffect(() => {
    if (!phone || !/^\d{1,10}$/.test(phone)) {
      setIsError(true);
      setIsInValidPhone(!!phone);
      return;
    }
    setIsInValidPhone(false);

    if (!isCheck) {
      setIsError(true);
      return;
    }
    setIsError(false);
  }, [isCheck, phone]);


  const changeBackGround = () => {
    if (window.scrollY > 20) {
      setNavbar(true);
    } else setNavbar(false);
  };
  window.addEventListener("scroll", changeBackGround);

  const HandleConsent = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    if (checked) {
      localStorage.setItem("consentChecked", "true");
      setConsent(!!localStorage.getItem("consentChecked"))
      setIsCheck(true)
    } else {
      localStorage.removeItem("consentChecked");
      setConsent(!!localStorage.getItem("consentChecked"))
      setIsCheck(false)
    }
  }

  const HandleCheckbox = () => {
    if (consent) {
      setIsCheck(!isCheck)
    } else {
      setShowConsentForm(true)
    }
  }

  const renderSwiper = (data: any[]) => {
    return (
      <Row className="row-space swiper-wrapper-custom">

        <Swiper
          spaceBetween={12}
          slidesPerView={1}
          modules={[Navigation]}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          breakpoints={{
            576: {
              slidesPerView: Math.min(data.length, 2),
              spaceBetween: 12,
            },
            768: {
              slidesPerView: Math.min(data.length, 2),
              spaceBetween: 12,
            },
            1024: {
              slidesPerView: Math.min(data.length, 5),
              spaceBetween: 12,
            },
            1440: {
              slidesPerView: Math.min(data.length, 6),
              spaceBetween: 20,
            },
          }}
        >
          <div className="swiper-button-prev swiper-button-disabled">
            <img src={img.ChevronLeft} />
          </div>
          {data.map((item) => {
            return (
              <SwiperSlide key={item.id} className="h-auto">
                <img src={item.url} alt={`Dabur ${item.id}`} className="swiper-image-login" />
              </SwiperSlide>
            );
          })}
          <div className="swiper-button-next swiper-button-disabled">
            <img src={img.ChevronRight} />
          </div>
        </Swiper>
      </Row>

    )
  }


  return (
    <>
      {/* <Navigate /> */}
      {/* <HeaderBar /> */}
      <div className="mobile-hidden">
        <HeaderBar />
      </div>
      <div>
        <ContainerNavigate className={navbar ? "activeBg" : ""}>
          <Navigate />
        </ContainerNavigate>
      </div>

      <div className="login-header page-login">
        <Container>
          {/* <SwiperWrapper></SwiperWrapper> */}
          {!loading && raffleData.length > 0 ? renderSwiper(raffleData) : !loading && renderSwiper(imageurls)}
          <Row className="row-space-1">
            <Col>
              {showOtp ? (
                <Card className="card-register">
                  <div className="d-flex align-items-end justify-content-between">
                    <span className="uppercase card-title">Enter your otp</span>
                    <img
                      src={imagePath}
                      width={100}
                      height={60}
                    />
                  </div>
                  <div className="otp-input-container">
                    <input type="type" maxLength={4} className="otp-input" value={otp} onChange={e => setOtp(e.target.value)} />
                    <button className="enter-btn" type="button" onClick={() => onVerify()}
                      disabled={!otp}>Enter</button>
                  </div>

                  <div className="form-control-feedback" hidden={!isError} >
                    Incorrect OTP
                  </div>

                  <p className="timer-text">Request another OTP in {showTime(timer)} secs</p>

                  <button className="new-otp-btn" type="button" onClick={() => onSend()} disabled={showOtp && timer !== 0}>
                    {timer !== 0 ? `${showTime(timer)} secs ` : <span className="arrow">New Otp →</span>}
                  </button>

                </Card>
              ) : (
                <Card className="card-register">
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="uppercase card-title">to start winning log
                      in with your mobile
                      and get an otp</span>
                    <img
                      src={theme.logoImage1 || imagePath}
                      width={100}
                      height={60}
                    />
                  </div>
                  <Form className="register-form">
                    <div
                      className={
                        isError && isCheck && !showOtp
                          ? "has-danger form-group"
                          : "form-group"
                      }
                    >

                      <div className="input-box">
                        <span style={{ color: "var(--primary-color)" }}>+91</span>
                        <input type="text" placeholder="" value={phone}
                          maxLength={15}
                          onChange={(e) => setPhone(e.target.value)} />
                        <button
                          onClick={() => onSend()}
                          type="button"
                          disabled={!isCheck || !phone}>
                          Enter
                        </button>
                      </div>
                      <div
                        className="form-control-feedback"
                        hidden={!isInValidPhone}
                      >
                        Invalid phone number format
                      </div>
                    </div>

                  </Form>
                  <FormGroup check>
                    <Label check>
                      <Input
                        defaultValue=""
                        type="checkbox"
                        onChange={HandleCheckbox}
                        checked={isCheck}
                      // disabled={!consent}
                      />
                      <span className="form-check-sign" />
                    </Label>
                    <PolicyDescription>
                      "By clicking this, you agree to {" "}
                      <span
                        onClick={() => setShowConsentForm(true)}
                        className="terms-link"
                      >Consent Form </span> WNNR’s {" "}
                      <span
                        onClick={() => setShowTermAndCondition(true)}
                        className="terms-link"
                      >Terms and Conditions </span> and <span
                        onClick={() => setShowPrivacyPolicy(true)}
                        className="terms-link"
                      >Privacy Policy</span>. Please take
                      a moment to review these documents as they outline
                      your rights and responsibilities.
                    </PolicyDescription>
                  </FormGroup>
                </Card>
              )}
            </Col>


            <Col>
              <Card className="card-register card-sign-up">
                <div className="d-flex align-items-center bg-yellow-logo" style={{ position: "relative" }}>
                  <div className="sign-up-div" style={{ flex: 1 }}>
                    <div><img src={theme.logoImage3 || welcome} alt="welcome-image" className="welcomeImage"/></div>
                    <div><img src={theme.logoImage2 || imagePath} alt="Dabur Logo" className="wnnrImage"/></div>
                    <div><span className="uppercase winners-club">Winners Club</span></div>
                  </div>
                  {/* Center vertical white line */}
                  <div className="vertical-divider" />
                  <div className="sign-up-div" style={{ flex: 1 }}>
                    <div><img src={theme.logoImage4 || signup} alt="signup-image" className="signupImage"/></div>
                    <div className="access-div"><span className="access-text">GET ACCESS TO HUNDREDS OF RAFFLES & GAMES TO WIN FREE REWARDS EVERY DAY!</span></div>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
        <PopUp
          visible={showTermAndCondition}
          onOk={() => {
            setShowTermAndCondition(false);
          }}
          title={"Terms And Condition"}
          onCancel={() => setShowTermAndCondition(false)}
        >
          <PopupWrapper>
            <div className="wrapper-content">
              <p>
                {" "}
                1. Website Description daburgamecenter.com is an online platform offering
                users opportunities to participate in various gaming activities
                and earn rewards. By engaging in specified digital actions,
                users can earn tickets and points which can be redeemed for
                various prizes, including entry into raffles and other
                competitions.{" "}
              </p>
              <p>
                2. User Eligibility To use daburgamecenter.com, you must: - Be a resident of
                India. - Be at least 18 years old. - Possess a valid PAN card
                and Aadhar card for verification purposes.
              </p>{" "}
              <p>
                3. Acceptance of Terms By accessing and using daburgamecenter.com, you agree
                to comply with and be bound by these Terms and Conditions. If
                you do not agree with any part of these terms, you must not use
                the website.
              </p>
              <p>
                4. User Accounts - Account Creation: To participate in
                activities on daburgamecenter.com, you must create an account and provide
                accurate, complete information. - Account Security: You are
                responsible for maintaining the confidentiality of your account
                information and for all activities that occur under your
                account. - Account Termination: daburgamecenter.com reserves the right
                to terminate or suspend your account at any time for any reason,
                including violations of these terms.
              </p>
              <p>
                5. User Responsibilities - Accurate Information: Provide
                accurate and current information during registration and keep
                your profile information up to date. - Lawful Use: Use the
                platform only for lawful purposes and in accordance with these
                terms. - Prohibited Activities: Do not engage in fraudulent
                activities, use multiple accounts, or exploit the platform in
                any unauthorized manner.
              </p>
              <p>
                6. Intellectual Property - Ownership: All content, features,
                and functionality on daburgamecenter.com are the exclusive property of Two
                Trees Ventures Pvt Ltd or its licensors. - Usage Rights:
                Users are granted a limited, non-exclusive license to use the
                platform for personal, non-commercial use, subject to these
                terms.
              </p>
              <p>
                7. Disclaimer of Warranties daburgamecenter.com is provided on an "as is"
                and "as available" basis. We make no warranties or
                representations of any kind, express or implied, regarding the
                operation or availability of the website, or the information,
                content, or materials included on the website.
              </p>
              <p>
                8. Limitation of Liability In no event shall daburgamecenter.com, its
                directors, employees, or affiliates be liable for any direct,
                indirect, incidental, special, or consequential damages arising
                out of or in any way connected with the use of or inability to
                use the website or for any content obtained through the website.
              </p>
              <p>
                9. Indemnification You agree to indemnify, defend, and hold
                harmless daburgamecenter.com, its officers, directors, employees, and
                affiliates from any claims, liabilities, damages, losses, or
                expenses arising out of or in any way connected with your access
                to or use of the website.
              </p>
              <p>
                10. Governing Law (India) These terms and conditions shall be
                governed by and construed in accordance with the laws of India,
                without regard to its conflict of law principles.
              </p>
              <p>
                11. Dispute Resolution - Informal Resolution: In the event
                of any dispute, you agree to first attempt to resolve the
                dispute informally by contacting support@daburgamecenter.com. -
                Arbitration: If the dispute cannot be resolved informally,
                it shall be resolved by binding arbitration in accordance with
                the Arbitration and Conciliation Act, 1996. The arbitration
                shall be conducted in Bangalore, India, and the language of
                arbitration shall be English.a By using daburgamecenter.com, you acknowledge
                that you have read, understood, and agree to be bound by these
                Terms and Conditions. For any questions or concerns, please
                contact support@daburgamecenter.com
              </p>
            </div>
          </PopupWrapper>
        </PopUp>

        <PopUp
          visible={showConsentForm}
          onOk={() => {
            setShowConsentForm(false);
          }}
          title={"Consent"}
          onCancel={() => setShowConsentForm(false)}
        >
          <PopupWrapper>
            <div className="wrapper-content">
              <p>
                {" "}
                By submitting this form and participating in
                win.daburshop.com’s raffles, games, and promotional
                activities, you agree to receive marketing communications
                from Dabur Game Center and Dabur India Limited. By checking the box
                below and providing your details, you explicitly consent to:{" "}
              </p>
              <p>
                Receiving emails, SMS, and other communications related
                to special offers, promotions, and product updates from
                Dabur Game Center and Dabur.
              </p>{" "}
              <p>
                Allowing Dabur Game Center to process your data for engagement
                tracking, personalized recommendations, and promotional
                offers.
              </p>
              <p>
                Being part of brand-specific engagement campaigns
                designed to provide exclusive rewards and offers.
              </p>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={consent}
                    onChange={e => HandleConsent(e)}
                  />
                  <span className="form-check-sign" />
                  <p>
                    I consent to receive marketing communications from
                    Dabur Game Center and Dabur, as outlined in this form.
                    You may opt out at any time by clicking the "unsubscribe"
                    link in any email or by adjusting your communication
                    preferences within the Dabur Game Center platform. For more details on
                    how your data is used and protected, please refer to our{" "}
                    <span
                      onClick={() => setShowPrivacyPolicy(true)}
                      className="terms-link"
                    >Privacy Policy</span> below.
                  </p>
                </Label>
              </FormGroup>
              <div>
                <button className="enter-btn" type="button" onClick={() => setShowConsentForm(false)}
                >Accept</button>
              </div>
            </div>
          </PopupWrapper>
        </PopUp>

        <PopUp
          visible={showPrivacyPolicy}
          onOk={() => {
            setShowPrivacyPolicy(false);
          }}
          title={"Privacy Policy"}
          onCancel={() => setShowPrivacyPolicy(false)}
          okText="No"
          cancelText="Yes"
        >
          <PopupWrapper>
            <div className="wrapper-content">
              <p>
                This privacy policy (hereinafter “Privacy Policy”) governs the
                collection, use, storage, disclosure, transfer or processing of
                personal information by Dabur Game Center (hereinafter “Dabur Game Center” OR “we or us”) or
                other software and application, in relation to the services
                offered by us. Any external links to other websites are clearly
                identifiable as such, and we are not responsible for the content
                or privacy policies of the other websites. We recognize the
                importance of the user (hereinafter “you”) privacy and respect
                that you want to safeguard the personal information shared with
                us. We make it our priority to ensure that your personal
                information remains secure and confidential and is used only for
                the intended purpose. In this Privacy Policy we explain our
                practices regarding personal information we collect when you use
                and/or access the Website. By accepting the terms of this Privacy
                Policy, you are providing your consent for the practices and
                reasons as described herein.
              </p>
              <p>
                General terms. This Privacy Policy describes how we collect, use,
                consult or process any personal information provided by you
                through the Website. This Privacy Policy is intended to inform you
                how we gather, define, and use the information that is provided to
                us when you access and/or use our Website. Dabur Game Center may change or
                amend this Privacy Policy from time to time to incorporate
                necessary future changes. The use of data by Dabur Game Center shall always be
                in adherence to this Privacy Policy under which the information
                was collected, regardless of new or conflicting provisions in an
                updated Privacy Policy. Dabur Game Center terms require all account owners to
                be at least eighteen (18) years of age (or have the permission and
                supervision of a responsible parent or legal guardian), therefore
                this Policy does not discuss the use of our Site by minors. Please
                read through this Privacy Policy to better understand what data we
                use and how we use your data for each of the above
                classifications. Collection of Data. Identifiable Information.
                When you share a post to your social media account, our interface
                will ask you to verify via an OTP. Once the OTP verifies you as a
                user, you will choose and enter your preferred game. After your
                registered contact number is verified, you are required to submit
                more personal information, including but not limited to your name,
                e-mail, location, gender, date of birth. This information provided
                by you can be termed as “Personal Information” as this can be used
                to identify you. Non-identifiable Information. As you use the
                website or Services as provided by us, our back-end server may
                automatically log the standard data provided by your browser. This
                data is considered “non-identifiable data,” as it does not
                personally identify you on its own. It may include your browser
                type, your IP address, geo-location data, etc. We also collect
                information to understand your preferences based on the responses
                provided by you for the questions asked while accessing our
                website or Services. The information we collect can depend on the
                webpage from where you can access our website, we recommend
                reading the privacy policies of the said webpage to understand
                what is the information they have access to. Use of Data. We use
                the information as provided by you for following purposes: Analyse
                the collective information provided by you to understand your
                preferences, likes and consumer behaviour; To create a database
                for purpose of analysing consumer behaviour; To analyse your
                interest, google analytics, consumer behaviour for the purpose of
                target and performance marketing, opinion polls, consumer data
                intelligence, based on target audience and profile; To offer an
                improved user experiences – we use the information (both Personal
                Information and non-identifiable data) to assist us to improve and
                optimize our Service and to personalize and customize your
                experience; Communication, marketing, and promotional activities –
                we may use information to deliver and personalize our
                communication with you or to administer rewards, surveys, contests
                and other promotional activities. Sharing User Data. We work with
                trusted third-party service providers and/or websites, wherein we
                provide third-party anonymised information for the purpose of
                advertisements based on target marketing and promotions by the
                particular third-party service providers. We share the data report
                or analysis with the publishers for the purpose of running
                performance campaigns, opinion polls based on the target audience
                and profile, based on the opinions and sentiments as gathered from
                you. We shall share your information to fulfil any obligations
                under any law for the time being to disclose any such information
                to the state (state herein refers to India). We shall share your
                information for compliance with any judgement or decree or order
                issued under any law or any judgement or order relating to claims
                of contractual or civil nature under any law for the time being in
                force outside India; We shall share your information in the event
                of medical emergency involving a threat to life or in the event of
                an immediate threat to life. We shall share your information in
                the event wherein it is required to apply appropriate measures to
                provide medical treatment or health services for you. We shall
                share your information with the authorities, as and when required,
                to ensure safety, or provide assistance or services during any
                disaster, or any breakdown of public order. Security We understand
                that the security of your information is important. We use
                industry standard measures to protect your information that is
                stored in our database. We follow industry standard best practices
                for information security. We limit the access to your personal
                information to those who need access to perform their job function
                and not beyond that. Rights under the Data Protection Laws As the
                User (or consumer), you are provided certain rights under the
                current data protection regime: You have the right to access
                information about your personal information as provided to us by
                you, provided the request is made in a manner as prescribed in the
                corresponding law or rules. In the event of any amendment or
                deleting or updating your information provided to us, you have the
                right to update or amend or delete the information, provided that
                the request is made in a manner as prescribed in the corresponding
                law or rules. You have the right to withdraw your consent from
                providing any further information, provided that the request is
                made in a manner as prescribed in the corresponding law or rules.
                You may make a request directing us to deleting your information
                and upon the receipt of such request we are obligated to act in
                accordance to the request, provided that the retention of your
                information is necessary for a specified purpose or compliance as
                maybe provided by the law. Contact Us If you have any queries or
                concerns regarding this Privacy Policy, you may reach us out
                directly on the following details: Email: support@daburgamecenter.com Mailing
                Address: 96/4 Chokkanahalli Main Road, S9, Surbacon Aspen,
                Bangalore, Karnataka, 560064
              </p>
            </div>
          </PopupWrapper>
        </PopUp>
      </div>
    </>
  );
};

export default Preview;
